import { simpleFetch, setLang } from "./acCommon"
import { findNotificationPreferenceTypeById, NotificationPreferenceType } from "../helpers/NotificationPreferenceType"

export const ACCOUNT_PROFILE_DATACHANGE = 'ACCOUNT_PROFILE_DATACHANGE'
export const accountProfileDataChange = changes => ({ type: ACCOUNT_PROFILE_DATACHANGE, changes })

export const ACCOUNT_PROFILE_METACHANGE = 'ACCOUNT_PROFILE_METACHANGE'
export const accountProfileMetaChange = changes => ({ type: ACCOUNT_PROFILE_METACHANGE, changes })

export const processDataChange = changes => (dispatch, getState) => {

	dispatch(accountProfileDataChange(changes))

	let { firstName, lastName, email, phone, title, lang } = getState().dataReducer.accountProfile

	if (email !== '' && firstName !== '' && lastName !== '' && phone !== '' && title !== '' && lang !== '') {
		dispatch(accountProfileMetaChange({ canSubmit: true }))
	}
	else {
		dispatch(accountProfileMetaChange({ canSubmit: false }))
	}
}
export const FETCH_ACCOUNT_PROFILE = 'FETCH_ACCOUNT_PROFILE'
export const FETCH_ACCOUNT_PROFILE_REQUEST = 'FETCH_ACCOUNT_PROFILE_REQUEST'
export const FETCH_ACCOUNT_PROFILE_SUCCESS = 'FETCH_ACCOUNT_PROFILE_SUCCESS'
export const FETCH_ACCOUNT_PROFILE_FAILURE = 'FETCH_ACCOUNT_PROFILE_FAILURE'
export const fetchAccountProfile = () => (dispatch, getState) => {
	dispatch(simpleFetch('/customers/profile/', { method: 'GET' }, FETCH_ACCOUNT_PROFILE))
}

export const ACCOUNT_PROFILE = 'ACCOUNT_PROFILE'
export const ACCOUNT_PROFILE_REQUEST = 'ACCOUNT_PROFILE_REQUEST'
export const ACCOUNT_PROFILE_SUCCESS = 'ACCOUNT_PROFILE_SUCCESS'
export const ACCOUNT_PROFILE_FAILURE = 'ACCOUNT_PROFILE_FAILURE'
export const saveAccountProfile = (notificationPreferences = null) => (dispatch, getState) => {

	let {
		dataReducer: {
			accountProfile: { email, firstName, lastName, phone, title, sodexoRef, secondaryPhone, landlinePhone, lang, sodexoRegion }
		}
	} = getState()

	let params = {
		email: email,
		first_name: firstName,
		last_name: lastName,
		telephone: phone,
		secondary_phone: secondaryPhone,
		landline_phone: landlinePhone,
		sodexo_reference: sodexoRef || null,
		sodexo_region: sodexoRegion,
		default_language: lang,
		title: title
	}

	if (notificationPreferences) {
		let prefs = [{
			label: NotificationPreferenceType.COMMUNICATION_BOOKINGS.backendId,
			notification_type: NotificationPreferenceType.COMMUNICATION_BOOKINGS.notificationType,
			value: true,
			origin: 'PCW'
		}]
		console.log(notificationPreferences)
		let keys = Object.keys(notificationPreferences)
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i]
			let pref = notificationPreferences[key]
			let notificationType = findNotificationPreferenceTypeById(key)
			prefs.push({
				label: notificationType.backendId,
				notification_type: notificationType.notificationType,
				value: pref,
				origin: 'PCW'
			})
		}
		params['account_notification_preferences'] = prefs
	}

	let body = JSON.stringify(params)

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_account_profile',
	}

	dispatch(simpleFetch('/customers/profile/', {
		method: 'PUT',
		body: body
	}, ACCOUNT_PROFILE, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === ACCOUNT_PROFILE_SUCCESS) {
			dispatch(setLang(lang))
		}
	})
}



// WEBPACK FOOTER //
// ./src/actions/acAccountProfile.js